import styled from 'styled-components';
import { PieChart } from './pie-chart';
import { PieChartLabels } from './pie-chart-labels';
import { PieChartEmptyState } from './pie-chart-empty';
import { VerticalBarchart } from '../bar-chart/barchart';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { MainAccordion } from 'modules/components/common';
import { Dropdown } from '../dropdown/dropdown';
import BarChartStyles from 'assets/css/vertical-barchart.module.css';

export const PieChartContainer = ({ selectedRangeData }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const charts = (
    <div style={{ padding: '8px 16px 16px' }}>
      {selectedRangeData?.daysWithTest !== 0 ? (
        <div dir="rtl">
          <PieChart
            high={selectedRangeData?.highGlucoseCount}
            low={selectedRangeData?.lowGlucoseCount}
            inrange={selectedRangeData?.inRangeGlucoseCount}
          />
          <div className="pie-labels-container">
            <PieChartLabels />
          </div>
          <div className="pie-divider" />
          <div className="vertical-barchart">
            <VerticalBarchart data={selectedRangeData?.hourlies} />
          </div>
        </div>
      ) : (
        <PieChartEmptyState />
      )}
    </div>
  );

  const mobileView = (
    <div className="mobile-view">
      <MainAccordion header="Meet glucose targets" open={'panel1'}>
        {charts}
        {selectedRangeData?.daysWithTest > 0 && (
          <div className={BarChartStyles.barchart_avg_wrapper}>
            <span className={BarChartStyles.total_avg_gray}>
              Total average:
            </span>
            <span className={BarChartStyles.total_avg}>
              {selectedRangeData?.resultAverage} mg/dl
            </span>
          </div>
        )}
        <Dropdown>
          <TextAccordion>
            This section provides an overview of the overall glucose management
            by categorizing glucose values in 3 segments: "Points in Range"
            which represents the percentage of values that fall into the
            desirable{' '}
            <span className="green">
              target range (70-180 mg/dL) and is presented in Green
            </span>
            ; "Points Below Range" which represents the percentage of values
            that fall below the{' '}
            <span className="red">
              target range (<span>&#60;</span>70mg/dL) and is presented in Red
            </span>
            ; and "Points Above Range" which represents the percentage of values
            that fall above the{' '}
            <span className="Yellow">
              target range {`(>180mg/dL)`}and is presented in Yellow
            </span>
            . The doughnut chart provides insight on your patient's overall
            glucose management and fluctuations, while the bar chart also helps
            you better identify the times of day that blood glucose needs
            tighter control or more SMBG is required.
          </TextAccordion>
        </Dropdown>
      </MainAccordion>
    </div>
  );

  const webView = (
    <div className="web-view">
      <p className="title">Meet glucose targets</p>
      {charts}
      {selectedRangeData?.daysWithTest > 0 && (
        <div className="chart-avg">
          <p>Total average: {selectedRangeData?.resultAverage} mg/dl</p>
        </div>
      )}
    </div>
  );

  return <StyledPiechart>{!isDesktop ? mobileView : webView}</StyledPiechart>;
};

const TextAccordion = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  direction: ltr;
  color: #4e4e4e;
  margin-bottom: 15px;
  .red {
    color: #d81d5d;
    font-family: 'dana-bold';
  }
  .green {
    color: #3bba4c;
    font-family: 'dana-bold';
  }
  .Yellow {
    color: #feb140;
    font-family: 'dana-bold';
  }
`;

const StyledPiechart = styled.div`
  width: 100%;
  .web-view {
    .title {
      color: #753cbe;
      font-size: 28px;
      font-family: 'dana-bold';
      letter-spacing: 1px;
      text-align: center;
      width: 390px;
      border-bottom: 2px solid #d8d8d8;
      margin: auto;
      padding-bottom: 17px;
      padding-top: 50px;
    }
  }
  .pie-labels-container {
    margin-bottom: 17px;
  }
  .pie-divider {
    margin-top: 18px;
    margin-bottom: 33px;
    width: 100%;
    height: 2px;
    background: #ffffff;
  }
  @media screen and (min-width: 1024px) {
    background: #f9fafb;
    padding: 0 64px;
    padding-bottom: 80px;

    .chart-avg {
      margin: 40px 32px 0 0;
      font-size: 20px;
      font-family: 'dana-bold';
      letter-spacing: 1px;
      text-align: center;
      color: #753cbe;
      height: 60px;
      background: rgba(59, 186, 76, 0.1);
      border-radius: 16px;
      display: grid;
      place-content: center;
      width: 520px;
    }

    .vertical-barchart {
      margin: 0 15px;
    }

    .pie-labels-container {
      padding: 17px;
    }
    .pie-divider {
      height: 1px;
      margin-top: 64px;
      margin-bottom: 96px;
      background: #d8d8d8;
    }
  }
`;
